import React, { useState } from "react";

const About = ({
  subtitle = "About Us",
  title = "About Unigenius Consultants",
  content1 = "Unigenius Consultants is a UK-based education consultancy built with a simple belief that everyone deserves a second chance, regardless of their past. Many people feel stuck in low-paying jobs, held back by a lack of qualifications, or believe that university is no longer an option for them. We exist to change that.",
  content2 = "We specialise in helping adults access flexible university degree programmes in the UK, even if they do not have traditional qualifications such as A-levels. Our focus is on people who are working, unemployed, or trying to improve their financial situation but don't know where to start. We understand the challenges they face because we work closely with individuals from all walks of life who are looking for a practical way forward.",
  content3 = "At Unigenius, we keep things simple. From your first enquiry, we take the time to understand your situation, explain your options clearly, and guide you through every step of the process. This includes helping you choose the right course, preparing your application, supporting your personal statement, and guiding you through interviews and student finance. Our support continues even after you enrol, ensuring you stay on track throughout your studies.",
  content4 = "What makes us different is that we do not treat this as just an admissions service. We see it as a journey of transformation. Many of the people we support come to us feeling uncertain, lacking confidence, or unsure about their future. By the time they begin their studies, they feel more confident, motivated, and in control of their direction in life.",
  content5 = "Our service is completely free because we believe financial barriers should not stop anyone from accessing education. We are committed to providing honest, clear, and professional guidance without unnecessary complications.",
  image1 = "https://res.cloudinary.com/dg0eeyvud/image/upload/v1768736358/banner-2_zvhllj.jpg",
  image2 = "https://themewagon.github.io/HighTechIT/img/about-2.jpg",
}) => {
  const [hoveredTeamIndex, setHoveredTeamIndex] = useState(null);

  const teamMembers = [
    {
      name: "Amir Iqbal",
      role: "Director",
      bio: "Amir founded the company and plays a key role in its growth and success. He is involved in a range of activities, including business development, strategic decision-making, and supporting the day-to-day operations of the organisations.",
    },
    {
      name: "Samar Iqbal",
      role: "Director",
      bio: "Samar oversees the strategic management and direction of the company. His role involves supporting different areas of the business, including operations and client relations to ensure the company operates efficiently and continues to grow.",
    },    
    // {
    //   name: "Kinza Zafar",
    //   role: "Branch Manager",
    //   bio: "Kinza is responsible for managing daily branch activities and ensuring that every student has a positive experience. She focuses on team coordination, service quality, and making sure that each enquiry is handled with care and attention.",
    // },
    {
      name: "David Salins",
      role: "Operations Manager",
      bio: "David oversees the day-to-day running of the business, ensuring that all processes are efficient and that our partnerships with universities and colleges are strong and reliable. His experience in business operations helps maintain a structured and professional environment where students receive consistent support.",
    },
    {
      name: "Reedwan Ibrahim",
      role: "Marketing Manager",
      bio: "Reedwan is responsible for delivering in-person marketing activities to promote the company and engage with potential customers. His main goal is to build relationships with clients and to generate new opportunities.",
    },
    // {
    //   name: "Faizan Zeb",
    //   role: "Admissions Manager",
    //   bio: "Faizan plays a key role in guiding students through the university application process. He works closely with applicants to identify suitable courses and ensures that every application is prepared to meet university requirements and maximise the chances of acceptance.",
    // },
    {
      name: "Mahnoor Khan",
      role: "Admissions Coordinator",
      bio: "Mahnoor supports the admissions process by managing applications, organising documentation, and making sure that each student's journey from enquiry to enrolment is smooth and well managed.",
    },
    {
      name: "Aiman Habib",
      role: "Student Finance Coordinator",
      bio: "Aiman assists students with their finance applications by explaining available funding options and ensuring that all information is completed accurately and submitted on time, helping students focus on starting their studies with confidence.",
    }
  ];

  const teamCardStyle = (index) => ({
    background: "#fff",
    borderRadius: "16px",
    padding: "36px 30px",
    border: `1px solid ${hoveredTeamIndex === index ? "#c2d4f0" : "#e4eaf4"}`,
    position: "relative",
    overflow: "hidden",
    transition:
      "transform 0.35s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.35s cubic-bezier(0.23, 1, 0.32, 1), border-color 0.35s ease",
    transform:
      hoveredTeamIndex === index
        ? "translateY(-10px) scale(1.02)"
        : "translateY(0) scale(1)",
    boxShadow:
      hoveredTeamIndex === index
        ? "0 24px 48px rgba(0, 44, 106, 0.13)"
        : "none",
    cursor: "default",
    height: "100%",
  });

  return (
    <div className="container-fluid py-5 my-5">
      <div className="container pt-5">

        {/* Top Section - Images + Intro Text */}
        <div className="row g-5 m-1">
          {/* Left Column - Images */}
          <div
            className="col-lg-5 col-md-6 col-sm-12 wow fadeIn"
            data-wow-delay=".3s"
            style={{
              visibility: "visible",
              animationDelay: "0.3s",
              animationName: "fadeIn",
            }}
          >
            <div className="h-100 position-relative">
              <img
                src={image1}
                className="img-fluid w-75 rounded"
                alt="About section main"
                style={{ marginBottom: "25%" }}
              />
              <div
                className="position-absolute w-75"
                style={{ top: "25%", left: "25%" }}
              >
                <img
                  src={image2}
                  className="img-fluid w-100 rounded"
                  alt="About section overlay"
                />
              </div>
            </div>
          </div>

          {/* Right Column - Text */}
          <div
            className="col-lg-7 col-md-6 col-sm-12 wow fadeIn"
            data-wow-delay=".5s"
            style={{
              visibility: "visible",
              animationDelay: "0.5s",
              animationName: "fadeIn",
            }}
          >
            <h5 className="text-primary">{subtitle}</h5>
            <h1 className="mb-4">{title}</h1>
            <p>{content1}</p>
            <p>{content2}</p>
            <p>{content3}</p>
            <p>{content4}</p>
            <p className="mb-4">{content5}</p>
          </div>
        </div>

        {/* YouTube Video */}
        <div className="row g-5 m-1 mt-4">
          <div
            className="ratio ratio-16x9 rounded overflow-hidden shadow-sm mt-4"
            style={{ border: "1px solid #eee" }}
          >
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/20ee2Ei5_S8?si=Q_wocooFn7jemmd-"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Team Section Header */}
        <div className="row m-1 mt-5">
          <div className="col-12 text-center mb-4">
            <h5 className="text-primary">Our People</h5>
            <h2>Meet the Team</h2>
            <p className="text-muted mx-auto" style={{ maxWidth: "650px" }}>
              Behind Unigenius Consultants is a dedicated team that works
              together to deliver a smooth and supportive experience for every
              student.
            </p>
          </div>
        </div>

        {/* Team Cards */}
        <div className="row g-4 m-1">
          {teamMembers.map((member, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              <div
                style={teamCardStyle(index)}
                onMouseEnter={() => setHoveredTeamIndex(index)}
                onMouseLeave={() => setHoveredTeamIndex(null)}
              >
                {/* Top accent bar */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "3px",
                    background: "linear-gradient(90deg, #002c6a, #1a5fb4)",
                    transform:
                      hoveredTeamIndex === index ? "scaleX(1)" : "scaleX(0)",
                    transformOrigin: "left",
                    transition:
                      "transform 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
                  }}
                />

                <div className="d-flex align-items-center mb-3">
                  {/* Avatar */}
                  <div
                    style={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "14px",
                      background:
                        hoveredTeamIndex === index ? "#002c6a" : "#eef3fb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.2rem",
                      fontWeight: 700,
                      color:
                        hoveredTeamIndex === index ? "#fff" : "#002c6a",
                      flexShrink: 0,
                      marginRight: "14px",
                      transition:
                        "background 0.3s ease, color 0.3s ease, transform 0.3s ease",
                      transform:
                        hoveredTeamIndex === index
                          ? "scale(1.08)"
                          : "scale(1)",
                    }}
                  >
                    {member.name.charAt(0)}
                  </div>

                  <div>
                    <h6
                      style={{
                        marginBottom: "2px",
                        fontWeight: 700,
                        color:
                          hoveredTeamIndex === index ? "#002c6a" : "#0d1b2e",
                        transition: "color 0.3s ease",
                        fontSize: "1rem",
                      }}
                    >
                      {member.name}
                    </h6>
                    <small
                      style={{
                        color:
                          hoveredTeamIndex === index ? "#1a5fb4" : "#5a6a82",
                        fontWeight: 500,
                        transition: "color 0.3s ease",
                      }}
                    >
                      {member.role}
                    </small>
                  </div>
                </div>

                <p
                  style={{
                    fontSize: "0.88rem",
                    color: "#5a6a82",
                    lineHeight: 1.7,
                    margin: 0,
                  }}
                >
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Closing Banner */}
        <div className="row m-1 mt-5">
          <div className="col-12">
            <div
              style={{
                background: "linear-gradient(135deg, #002c6a 0%, #1a5fb4 100%)",
                borderRadius: "20px",
                padding: "44px 48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "32px",
                flexWrap: "wrap",
              }}
            >
              <div>
                <h3
                  style={{
                    fontSize: "1.7rem",
                    fontWeight: 700,
                    color: "#fff",
                    marginBottom: "8px",
                  }}
                >
                  One Team. One Goal.
                </h3>
                <p
                  style={{
                    fontSize: "0.95rem",
                    color: "rgba(255,255,255,0.75)",
                    lineHeight: 1.6,
                    maxWidth: "480px",
                    margin: 0,
                  }}
                >
                  Together, our team works with one shared goal — to help
                  individuals move forward in life with confidence, stability,
                  and real career opportunities.
                </p>
              </div>
              <div
                style={{
                  background: "rgba(255,255,255,0.15)",
                  border: "2px solid rgba(255,255,255,0.3)",
                  borderRadius: "100px",
                  padding: "14px 32px",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "1rem",
                  whiteSpace: "nowrap",
                  letterSpacing: "0.5px",
                }}
              >
                ✦ Your Future Starts Here
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;